export const STORAGE_TOKEN = "token";
export const STORAGE_SECRET_KEY = "secretKey";
export const STORAGE_CURRENT_LOGGED_USER = "currentUser";
